import { render, staticRenderFns } from "./EzuiPlayer.vue?vue&type=template&id=3020de8f&scoped=true"
import script from "./EzuiPlayer.vue?vue&type=script&lang=js"
export * from "./EzuiPlayer.vue?vue&type=script&lang=js"
import style0 from "./EzuiPlayer.vue?vue&type=style&index=0&id=3020de8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3020de8f",
  null
  
)

export default component.exports